import { AccountSupervisorIcon } from './AccountSupervisorIcon';

/**
 * author: Google
 * id DF632613-259D-4C5E-9718-0EB3057290AF
 * name account-supervisor
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-supervisor.svg
 * tags
 * - Account / User 
 */
export const PersonSupervisorIcon = AccountSupervisorIcon;
export default PersonSupervisorIcon